export const getLogoPlaceholder = (businessName) => businessName?.substring(0, 1).toUpperCase();
